<template>
  <div
    v-if="useBadge"
    class="progress-cell">
    <span
      v-if="isValueDefined"
      class="badge"
      :class="indicatorClassName">
      {{ value }}
    </span>
    <span v-else>{{ DASH }}</span>
  </div>

  <div
    v-if="useProgressBar"
    class="progress-cell">
    <span v-if="isValueDefined">
      {{ value }}
    </span>
    <div
      v-if="isValueDefined"
      class="progress-container"
      :class="indicatorClassName">
      <div
        class="progress"
        :style="`width: ${value}`" />
    </div>
    <span v-else>{{ DASH }}</span>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  import { DASH } from '@/globals';

  interface IProps {
    value: string;
    indicatorClassName: string;
    useBadge: boolean;
    useProgressBar: boolean;
  }

  const isValueDefined = computed(() => {
    return props.value !== DASH;
  });

  const props = withDefaults(defineProps<IProps>(), {
    useBadge: true,
    useProgressBar: false,
  });
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;
</style>
